import { useMemo, useState } from 'react';

export function useTablePagination<T>(values: Array<T>, defaultPerPage = 50) {
    const [rowsPerPage, setRowsPerPage] = useState(defaultPerPage);
    const [page, setPage] = useState(1);

    const onPageChange = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const onRowsPerPageChange = (value: number) => {
        setRowsPerPage(value);
        setPage(1);
    };

    const paginatedValues = useMemo(
        () => values.slice((page - 1) * rowsPerPage, (page - 1) * rowsPerPage + rowsPerPage),
        [values, page, rowsPerPage]
    );

    const count = useMemo(() => values.length, [values]);

    return {
        onRowsPerPageChange,
        paginatedValues,
        onPageChange,
        rowsPerPage,
        setPage,
        count,
        page
    };
}
